import IndicatorScreen from 'components/indicator/IndicatorScreen';

import SettingModalMemberInvitation from './components/SettingModalMemberInvitation';
import { useSettingMember } from './hooks/useSettingMember';
import { getDivLabel } from 'utils/app';

import type { JSX } from 'react';

/**
 * カンパニーメンバー設定画面
 */
export default function SettingMember(): JSX.Element {
  const {
    initialized,
    processing,
    membersParticipatedState,
    membersInvitedState,
    setMembersInvitedState,
    invitationModalOpen,
    setInvitationModalOpen,
    isAdmin,
    onInvite,
    onEdit,
    onInvitationResend,
    onInvitationDelete,
  } = useSettingMember();

  return (
    <>
      <section className="section-header">
        <div className="container">
          <div className="d-md-flex d-flex-header">
            <div className="flex-shrink-0 flex-left">
              <h2 className="flex-title">ユーザーの一覧</h2>
            </div>
            {isAdmin && (
              <div className="flex-grow-1 flex-right">
                <ul className="list-inline list-btn mb-0">
                  <li className="list-inline-item">
                    <a onClick={onInvite} className="btn btn-common btn-common-w147 moderate-blue">
                      ユーザー追加
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 初期化中の表示 */}
      <IndicatorScreen visible={!initialized || processing} />
      {/* 初期化後の表示 */}
      {initialized && (
        <>
          {/* 参加済のユーザー一覧 */}
          <section className="section-users">
            <div className="container">
              <ul className="list-unstyled list-users d-flex flex-wrap justify-content-start align-items-start">
                {membersParticipatedState.map(item => {
                  return (
                    <li key={item.member.id}>
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-name">{item.user?.name}</h5>
                          <h6 className="card-position mb-2 text-muted">
                            {getDivLabel('role', item.member?.roleDiv)}
                          </h6>
                          <p className="card-email">{item.user?.mailAddress}</p>
                          {isAdmin && (
                            <a
                              onClick={() => onEdit(item)}
                              className="btn btn-common d-inline-block moderate-blue"
                            >
                              編集
                            </a>
                          )}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </section>
          {/* 招待中のユーザー一覧 */}
          {membersInvitedState.length > 0 && (
            <>
              <section className="section-header">
                <div className="container">
                  <div className="d-md-flex d-flex-header">
                    <div className="flex-shrink-0 flex-left">
                      <h2 className="flex-title">招待中ユーザーの一覧</h2>
                    </div>
                  </div>
                </div>
              </section>
              <section className="section-users">
                <div className="container">
                  <ul className="list-unstyled list-users d-flex flex-wrap justify-content-start align-items-start">
                    {membersInvitedState.map(item => {
                      return (
                        <li key={item.member.id}>
                          <div className="card">
                            <div className="card-body">
                              <h5 className="card-name">No Name</h5>
                              <h6 className="card-position mb-2 text-muted">
                                {getDivLabel('role', item.member?.roleDiv)}
                              </h6>
                              <p className="card-email">{item.member.invitationMailAddress}</p>
                              {isAdmin && (
                                <>
                                  <a
                                    onClick={() => onInvitationResend(item)}
                                    className="btn btn-common d-inline-block moderate-blue me-2 mb-2"
                                  >
                                    再送信
                                  </a>
                                  <a
                                    onClick={() => onInvitationDelete(item)}
                                    className="btn btn-common d-inline-block outline-blue mb-2"
                                  >
                                    招待取消
                                  </a>
                                </>
                              )}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </section>
            </>
          )}
          {/* カンパニーメンバー招待モーダル */}
          <SettingModalMemberInvitation
            open={invitationModalOpen}
            setOpen={setInvitationModalOpen}
            membersInvitedState={membersInvitedState}
            setMembersInvitedState={setMembersInvitedState}
          />
        </>
      )}
    </>
  );
}
